import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {Action} from '@fantasmagames/slot/src/logic/Action';

export class AvalancheReelsBasicState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStartedByButton);
	}

	protected onSpinStartedByButton(): void {
		if (this.module.logic.nextAction === Action.SPIN || this.module.logic.nextAction === Action.FREESPIN) {
			this.module.gotoState(AvalancheReelsModule.DROPOUT_STATE);
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsBasicState.ts